import { useForm } from 'react-hook-form'
import { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import '../../styles/swicthcss.css'
import Swal from 'sweetalert2'
import { projectContext, loadingContext, urlValue, unfolder, openAlert } from '../../lib'
import SelectCodeModal from '../SelectCodeModal'
import SwitchBtn from '../common/SwitchBtn'
import ButtonYesNo from '../common/ButtonYesNo'
import BoxInfo from '../common/BoxInfo'
import { SelectNesting } from '../common/Inputs/Select'
import { InputNesting, TextareaNesting } from '../common/Inputs/Input'
import { Tooltip } from 'react-tooltip'
import { Alerts } from '../common/Alerts'

export function SettingsOptionsGenAI({ isModalOpen, closeModal, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [users, setUsers] = useState([{}])
  const [loading, setLoading] = useContext(loadingContext)
  const [nlp_config, setNlp_config] = useState(null);
  const [bot_type, setBot_type] = useState(false);
  const [default_Sentiment, setDefault_Sentiment] = useState(false);
  const [nlp_configName, setNlp_configName] = useState("Upload");
  const [language, setLanguage] = useState("EN-US");
  const [campaings, setCampaings] = useState([])
  const [subCampaings, setSubCampaings] = useState([])
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const [hold, setHold] = useState(0)
  const timeHoldRef = useRef();
  const timeHoldAmountRef = useRef();
  const sentimentBotRef = useRef();
  const useDefaultSentimentRef = useRef();
  const [radomVoice, setRadomVoice] = useState(false)
  const [voices, setVoices] = useState([])
  const [error, setError] = useState({ name: "" })
  const url_simulationRef = useRef();
  const affectation_time_ref = useRef();
  const percentage_affectation_ref = useRef();
  const [category, setCategory] = useState('outbound');
  const [transcription, setTranscription] = useState(0);
  const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
  const [timeHold, setTimeHold] = useState(0);
  const [amountTimeHold, setAmountTimeHold] = useState(0);
  const [modelSentiment, setModelSentiment] = useState('Voice');
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [channel, setChannel] = useState("voice")
  const [questions, setQuestions] = useState([{ question: "" }, { question: "" }, { question: "" }])
  const industry_ref = useRef();
  const problem_ref = useRef();
  const solucion_ref = useRef();
  const campaign_ref = useRef();
  const subcampaing_ref = useRef();
  const voice_ref = useRef();
  const welcome_mesageRef = useRef();
  const minimunCallDurations = useRef();
  const maxUserResponseTime = useRef();
  const contact_driver_context_ref = useRef();
  const bot_respose_time_ref = useRef();


  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const roles = {
    1: 'Admin',
    2: 'Manager',
    3: 'Editor',
    4: 'Reader',
  }


  const getUsers = async () => {

    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token


      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/user/users-project/${selectedProject.id}`,
        headers: {
          'access-token': token,
        },
      })

      setUsers(response.data)

      return response;
    } catch (error) {
      console.log(error)

      return error
    }

  }

  useEffect(() => {
    (async () => { await getUsers(); })()

  }, [])

  useEffect(() => {
    (async () => {

      await fetchVoice();
      await fetchCampaing();
      await fetchSubCampaing();
      await getProject();

    })()



  }, []);

  const ChangeModelSentiment = (e) => {
    if (e.target.value === 'Voice') {
      selectedProject.bot_sentiment = 0;
    }
  }

  const saveBotSentimentConfig = function (e) {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    axios({
      method: 'post',
      url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
      headers: {
        user: id,
        'access-token': token,
      },
      data: {
        bot_sentiment: e.target.value,
      }
    }).then(function (res) {
      // console.log('res');
    }).catch(error => {
      console.log('Error to try update bot sentiment: ', error);
    })
  }

  const saveProject = (e) => {
    e.preventDefault();
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    const name = selectedProject.name;

    const exp = /^[A-Za-z0-9-,._'\s]+$/g;
    if (!exp.test(name)) {
      ok = false;

      setError({ ...error, name: "The name cannot contain symbols and special characters." })
    }
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    if (ok) {
      const dataSend = {
        id: selectedProject.id,
        name: selectedProject.name,
        //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
        nlp: selectedProject.nlp,
        nlp_url: selectedProject.nlp_url,
        metadata: { "description": selectedProject.metadata.description, "language": selectedProject.metadata.language },
        //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
        image: selectedProject.image,
        hold: hold,
        time_hold_amount: timeHoldAmountRef.current?.value || 0,
        time_hold_seconds: timeHoldRef.current?.value || 0,
        use_hold: hold ? 1 : 0,
        channel: channel,
        random_voice: radomVoice ? 1 : 0,
        use_default_sentiment: selectedProject.use_default_sentiment,
        bot_sentiment: selectedProject.bot_sentiment,
        model_sentiment: selectedProject.model_sentiment,
        url_tp_simulation: url_simulationRef.current.value,
        category: category,
        outbound_call: category === 'outbound' ? 1 : 0,
        transcription: selectedProject.transcription,
        campaing: campaign_ref.current?.value,
        sub_campaing: subcampaing_ref.current?.value,
        voice: voice_ref.current.value,
        type: selectedProject.type,
        contact_driver_context: contact_driver_context_ref.current.value,

        // industry: industry_ref.current?.value,
        // problem: problem_ref.current?.value,
        // solution: solucion_ref.current?.value,
        evaluation_questions: questions,
        welcome_msg: welcome_mesageRef.current.value,
        min_call_time: minimunCallDurations.current?.value || 0,
        max_user_response_time: maxUserResponseTime.current?.value || 0,
        bot_response_time: bot_respose_time_ref.current?.value || 1,

      }
      axios({
        method: 'put',
        url: `${urlValue}/studio/project`,
        headers: {
          user: id,
          'access-token': token,
        },
        data: dataSend,
      })
        .then(function (response) {
          setSelectedProject({
            ...selectedProject,
            channel: channel,
            voice_id: voice_ref.current.value,
            campaing: campaign_ref.current?.value,
            sub_campaing: subcampaing_ref.current?.value,
            time_hold_amount: timeHoldAmountRef.current?.value || 0,
            time_hold_seconds: timeHoldRef.current?.value || 0,
            use_hold: hold ? 1 : 0,
            random_voice: radomVoice ? 1 : 0,
            type: selectedProject.type,
            // industry: industry_ref.current?.value,
            // problem: problem_ref.current?.value,
            // solution: solucion_ref.current?.value,
            contact_driver_context: contact_driver_context_ref.current.value,
            evaluation_questions: questions,
            welcome_msg: welcome_mesageRef.current.value,
            url_tp_simulation: url_simulationRef.current.value,
            category: category,
            outbound_call: category === 'outbound' ? 1 : 0,
            min_call_time: minimunCallDurations.current?.value || 0,
            max_user_response_time: maxUserResponseTime.current?.value || 0,
            bot_response_time: bot_respose_time_ref.current?.value || 1,
          })
          openAlert('#alert-ac', () => { setAlert({ title: 'Settings have been change properly!', visible: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
          getProject();
          setLoading(false)
        })
        .catch(function (error) {
          openAlert('#alert-ac', () => {setAlert({title: 'Settings could not save!!', visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
          console.error("error ", error)
        })
    }
  }

  const getProject = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    setLoading(true)
    try {
      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/project/${selectedProject.id}`,
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })

      setSelectedProject(response.data)

      // document.getElementById('url_tp_simulation').value = response.data.url_tp_simulation;
      // document.getElementById('bot_sentiment').value = response.data.bot_sentiment;

      setLanguage(response.data.metadata.language);
      setTimeHold(response.data.TimeSecondHold);
      setAmountTimeHold(response.data.AmountTimeHold);
      setRadomVoice(response.data.random_voice);
      setHold(response.data.useHold);
      setUseDefaultSentiment(response.data.use_default_sentiment)
      setTranscription(response.data.transcription)
      setCategory(response.data.category)
      setChannel(response.data.channel)


      // setCategory(response.data.outbound_call === 1 ? true : false)
      setTranscription(response.data.transcription)
      setUseDefaultSentiment(response.data.use_default_sentiment)
      setTimeHold(response.data.TimeSecondHold)
      setAmountTimeHold(response.data.AmountTimeHold)
      setModelSentiment(response.data.model_sentiment)
      setQuestions(response.data?.gen_ai.evaluation_questions || []);

      voice_ref.current.value = response.data.voice_id;
      // industry_ref.current.value = response.data?.gen_ai.industry;
      // problem_ref.current.value = response.data?.gen_ai.problem;
      // solucion_ref.current.value = response.data?.gen_ai.solution;
      contact_driver_context_ref.current.value = response.data?.gen_ai.contact_driver_context;
      campaign_ref.current.value = response.data.campaing_id;
      subcampaing_ref.current.value = response.data.sub_campaing_id;
      timeHoldRef.current.value = response.data.TimeSecondHold;
      timeHoldAmountRef.current.value = response.data.AmountTimeHold;
      url_simulationRef.current.value = response.data.url_tp_simulation;
      welcome_mesageRef.current.value = response.data.welcome_msg;
      minimunCallDurations.current.value = response.data.min_call_time || 0;
      maxUserResponseTime.current.value = response.data.max_user_response_time || 0;
      bot_respose_time_ref.current.value = response.data.bot_response_time || 0;

      setLoading(false)
      return response
    }
    catch (error) {
      console.log("Error GetProject", error)
      setLoading(false)
      return error;
    }

  }

  const changeBotType = e => {
    document.querySelectorAll(".list_bot_type .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setChannel(e.target.value);
  }

  const changeCallType = e => {
    document.querySelectorAll(".list_call_type .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setCategory(e.target.value);
  }

  const changeTranscriptionEnable = e => {
    document.querySelectorAll(".list_transcription_enable .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setTranscription(e.target.value);
  }

  const changeUseDefaultSentiment = e => {
    document.querySelectorAll(".list_use_default_sentiment .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    setUseDefaultSentiment(e.target.value);
  }

  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/voices/all`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          language: language.substring(0, 2)  || 'EN',
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
        //setTimeout(()=>{document.querySelector("#voice").value = selectedProject.voice_id },700);
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
      return rest;;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const industry = [
    { id: 1, name: "industry 1" },
    { id: 2, name: "industry 2" },
    { id: 3, name: "industry 3" },
  ]
  const onChangeQuestion = (e, index) => {
    const q = [...questions];
    q[index].question = e.target.value
    setQuestions(q)
  }

  const addQuestiong = () => {
    setQuestions((prev) => [...prev, { question: "" }])
  }

  const deleteQuestiong = (index) => {
    setQuestions((prev) => prev.filter((x, i) => i !== index))
  }


  return (
    <>
      <form onSubmit={saveProject} className="settings-container pt-2 pb-5 " style={{ backgroundColor: '#F9F9F9', paddingRight: 17, borderRadius: 25 }}>
        <div className="scroll-internal ">
          {/* <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18 }}>General Project Settings</h2> */}
          <div className="pl-3 d-flex flex-row" style={{ justifyContent: 'space-between' }}>
            <div className="d-flex flex-column pl-2" style={{ width: '100%', paddingRight: 15 }}>
              <h1 className='mt-2 mb-1' style={{ marginBottom: 2, marginTop: 15 }}>Contact Driver Context</h1>
              <div className='flex items-center'>
                <TextareaNesting
                  row={5}
                  ref={contact_driver_context_ref} id="contact_driver_context"
                  title="" containerClass="flex-1 mr-2 mt-0 "
                />
              </div>

              <div className='separator-n mt-4 mb-3' />

              <h1 className='mt-2 mb-1' style={{ marginBottom: 2, marginTop: 15 }}>Evaluation Formulary</h1>
              <div className='flex  flex-col  '>
                {questions?.map((item, index) => (
                  <div className='flex items-end flex-1'>
                    <InputNesting
                      containerClass="w-full"
                      defaultValue={item.question}
                      onChange={(e) => onChangeQuestion(e, index)}
                      title={`Question ${index + 1}:`}
                    />
                    <button type='button' className='ml-2 btn-delete  ' style={{ marginBottom: 3 }} onClick={() => deleteQuestiong(index)} >
                      <img src={'/icons/trash-1.png'} alt='' style={{ width: 22 }} />
                    </button>

                  </div>
                ))}
                <button className='btn-add mt-2' type='button' onClick={addQuestiong}>
                  <img src='/icons/add-icon-nt.png' style={{ width: 22 }} alt='' />
                  <span className='ml-5'>Add question</span>
                </button>
              </div>


              <div className="inputs" style={{ marginTop: 25, width: "100%" }}>
                <div className="input  flex flex-row  items-center"  >

                  <BoxInfo
                    id="bottype-tp" titleClass='mr-0-4'
                    title="Bot Type:"
                    place="top" containerClass='mr-0-5 '
                    content="Here you can select your bot type between outbound or inbound"
                  />
                  <div className="ml-2 list_bot_type d-flex flex-row align-items-center" >
                    <ButtonYesNo
                      onClick={() => setChannel((prev) => prev === "voice" ? "chat" : "voice")}
                      width={170}
                      state={channel === "chat" ? false : true}
                      height={30}
                      Yes='Voice Bot'
                      No='Chat Bot'
                    />
                  </div>
                </div>
              </div>
              {/* <div className="inputs">
                <div className="input d-flex flex-column" style={{ height: "auto" }}>
                  <span>URL TP Simulation:</span>
                  <input {...register('url_tp_simulation', { required: false })}
                    ref={url_simulationRef} defaultValue={selectedProject.url_tp_simulation} id="url_tp_simulation"
                    type="text" className="input-text mt-3" />
                </div>
              </div> */}
              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center">
                  <span>Interaction Type:</span>
                  <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                      width={170}
                      state={category === "outbound" ? true : false}
                      height={30}
                      Yes='Inbound'
                      No='Outbound'
                    />
                  </div>
                </div>
              </div>
              <InputNesting
                containerClass="mr-2"
                ref={url_simulationRef}
                id="url_tp_simulation"
                type="text"
                title="URL TP Simulation:"
              />
              <TextareaNesting
                containerClass="mr-2"
                ref={welcome_mesageRef}
                id="welcome_mesage"
                type="text"
                row={4}
                title="Welcome Mesage:"
              />

              <SelectNesting
                ref={campaign_ref} id="campaing"
                title="Campaign:" containerClass=" mr-2"
              >  {campaings.map((item, index) => (<option key={index} value={item.id}>{item.name}</option>))}
              </SelectNesting>


              <SelectNesting
                ref={subcampaing_ref} id="subcampaing"
                title="Sub-campaign:" containerClass=" mr-2"
              >  {subCampaings.map((item, index) => (<option key={index} value={item.id}>{item.name}</option>))}
              </SelectNesting>


              <div className="input">
                <div className=' flex   mt-3  w-100'>
                  <BoxInfo
                    id="ramvoice-tp" titleClass='mr-0-4'
                    title="On-Hold Availability:"
                    place="top" containerClass='mr-0-5 '
                    content="This option allowed the possibility to put on hold our interaction during the call"
                  />
                  <ButtonYesNo
                    onClick={() => setHold((prev) => !prev)}
                    width={140}
                    state={hold}
                    height={30}
                  />
                </div>
              </div>


              <div className=" flex flex-column  ">
                <InputNesting
                  ref={minimunCallDurations} id="minimunCallDurations"
                  type="number"
                  containerClass="mr-2"
                  title="Minimun call durations (minutes):"
                />
                <InputNesting
                  containerClass="mr-2"
                  ref={maxUserResponseTime} id="maxUserResponseTime"
                  type="number"
                  title="Max user response time (seconds):"
                />
              </div>
              <div className=" flex flex-row items-center">
                <InputNesting
                  ref={timeHoldRef} id="timehold"
                  type="number"
                  disabled={!hold}
                  containerClass="mr-2"
                  title="Hold time (seconds):"
                />

                <InputNesting
                  containerClass="mr-2"
                  ref={timeHoldAmountRef} id="timeholdamount"
                  type="number"
                  disabled={!hold}
                  title="Hold attempts:"
                />


              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>

                    <BoxInfo
                      id="ramvoice-tp"
                      titleClass='mr-0-4'
                      title="Use random voices?:"
                      place="top"
                      containerClass='mr-0-5 '
                      content="When you activate this feature means that your bot going to select random voices when the call starts"
                    />
                    <ButtonYesNo
                      onClick={() => setRadomVoice((prev) => !prev)}
                      width={150}
                      state={radomVoice}
                      height={30}
                    />
                  </div>
                </div>
              </div>


              <SelectNesting
                ref={voice_ref} id="voice"
                boxInfo={true} tooltipText="Here you can choose your favorite voice between male and female and different accents"
                title="Select voice:" containerClass=" mr-2"
              >  {voices.map((item, index) => (<option key={index} value={item.id}>{item.voice}</option>))}
              </SelectNesting>
              <InputNesting
                  ref={bot_respose_time_ref} id="bot_respose_time"
                  type="number"
                  containerClass="mr-2"
                  title="Reply time:"
                />
            </div>


            {/*<div className="settingsOptions-input p-3">*/}
            {/*  <span className="">Select voice</span>*/}
            {/*  <div className="select" style={{minWidth: 150}}>*/}
            {/*    <select disabled={true}>*/}
            {/*      <option value="default">default</option>*/}
            {/*    </select>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<div className="settingsOptions-input p-3">*/}
            {/*  <span>Model Sentiment</span>*/}
            {/*  <div className="select">*/}
            {/*    <select onChange={ChangeModelSentiment}>*/}
            {/*      <option value="Phrase" selected={selectedProject.model_sentiment ? 'selected' : ''}>Phrase</option>*/}
            {/*      <option value="Voice" selected={!selectedProject.model_sentiment ? 'selected' : ''}>Voice</option>*/}
            {/*    </select>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<div className="settingsOptions-input p-3">*/}
            {/*  <span>Bot Sentiment</span>*/}
            {/*  <div className="select">*/}
            {/*    <select onChange={saveBotSentimentConfig}>*/}
            {/*      <option value="1" selected={selectedProject.bot_sentiment !== 0 ? 'selected' : ''}>ON</option>*/}
            {/*      <option value="0" selected={selectedProject.bot_sentiment === 0 ? 'selected' : ''}>OFF</option>*/}
            {/*    </select>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          <div className='cont-buttons mt-5 w-100'>
            <div className="buttons d-flex flex-row justify-end pr-3">
              <button className="create btn-primary btn-bottom btn-bottom-create" type="submit" style={{ backgroundColor: "#0087FF" }}>
                Save
              </button>
            </div>
          </div>
        </div>

      </form>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} />}

      {/*<span>Enable Agent</span>*/}
      {/*<div className="type">*/}
      {/*  <input*/}
      {/*      type="radio"*/}
      {/*      id="text"*/}
      {/*      value="1"*/}
      {/*      defaultChecked="checked"*/}
      {/*  />*/}
      {/*  <label htmlFor="text">*/}
      {/*    <span>ON</span>*/}
      {/*  </label>*/}
      {/*  <input type="radio" id="ssml" value="2" disabled={true} />*/}
      {/*  <label htmlFor="ssml">*/}
      {/*    <span>OFF</span>*/}
      {/*  </label>*/}
      {/*</div>*/}

      {/*<div className="settingsOptions-input">*/}
      {/*  <div className="shared pb-3">*/}
      {/*    <h2 className="w-100 text-left" style={{color: '#0B5FA3', fontSize: 18}}>Role management</h2>*/}
      {/*    <div className="titles d-flex flex-row align-items-center justify-space-between w-100">*/}
      {/*      <p>CCMS ID</p>*/}
      {/*      <p>Rol</p>*/}
      {/*    </div>*/}
      {/*    {allUsers.users*/}
      {/*      .filter(value => {*/}
      {/*        return users.some(({ user }) => {*/}
      {/*          return value.id === user*/}
      {/*        })*/}
      {/*      })*/}
      {/*      .map(({ role, ccms_id }, index) => (*/}
      {/*        <div className="container d-flex flex-row align-items-center justify-space-between" key={index}>*/}
      {/*          <div>*/}
      {/*            <p className="p-1">{ccms_id}</p>*/}
      {/*          </div>*/}
      {/*          <div>*/}
      {/*            <select name="" className="select_role p-1">*/}
      {/*              <option value="{role}">{roles[role]}</option>*/}
      {/*            </select>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      ))}*/}
      {/*  </div>*/}
      {/*</div>*/}
    </>
  )
}
